module.exports = __webpack_public_path__ + "img/peta_cabang_tripwe.06010d37.png";